import { Box, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ContainerOfInputFields } from './ThemDesign'
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import helpers from '../assets/js/helper';

function CustomTextField({
    label,error,message,value,onChange,onClearClick,readOnly, type,haswidth,hasMultipleLine, customWidth,customePadding,
    focused,paddingHorizontal,onKeyDown,inputPropStyle,errorMessage,disable,customHeight,hasePassswordEye,maxHeight,labelColor,dir, rows, inputRef, placeholder, onFocus
}) {
    const maintheme=useSelector(state=>state.themeData.maintheme);
    const [showPassword,setShowPassword]=useState(null)

    
    return (
        <ContainerOfInputFields
            mainTheme={maintheme}
            customeWidth={customWidth?customWidth:"100%"}
            isForm={true}
            haswidth={haswidth?true:false}
            hasMultiLine={hasMultipleLine?true:false}
            paddingHorizontal={paddingHorizontal}
            customHeight={customHeight}
            maxHeight={maxHeight}
            dir={dir ? dir : helpers.checkTextDirection(value)}
            labelColor={disable ? "#5f8399" :labelColor}
        >
            <Box
                sx={{
                    position: "relative",
                    // margin: "5px 0",
                    width: "100%",
                    backgroundColor: "#fff",
                    padding:customePadding?customePadding:'auto'
                }}
                className="orderdata"
            >
                <TextField
                    
                    variant="filled"
                    label={label}
                    value={value}
                    onChange={(e) => onChange && onChange(e)}
                    type={type?showPassword?'text':type:'text'}
                    focused={focused?focused:true}
                    // ref={inputRef}
                    error={error}
                    helperText={errorMessage}
                    autoComplete="new-password"
                    multiline={hasMultipleLine?true:false}
                    rows={rows ? rows : null}
                    InputProps={{
                        readOnly:readOnly,
                        inputRef: inputRef,
                        placeholder: placeholder ? placeholder : "لم يتم التحديد",
                    }}
                    disabled={disable}
                    inputProps={{
                        style:{
                            ...inputPropStyle
                        }
                        
                    }}
                    
                    onFocus={onFocus}
                    className={`${error ? 'errors' : ''}`}
                    dir={dir ? dir : helpers.checkTextDirection(value)}
                    onKeyDown={onKeyDown}
                    
                />
                {hasePassswordEye&&value?
                !showPassword?<VisibilityIcon sx={{
                    color:'#1e6a99',
                    ...(dir ? dir : helpers.checkTextDirection(value)=='rtl'?{left:'35px !important'}:{right:'35px !important'})
                }} className="closeIcon " onClick={()=>setShowPassword(true)}/>:<VisibilityOffIcon className="closeIcon mr-4" sx={{
                    color:'#1e6a99',
                    ...(dir ? dir : helpers.checkTextDirection(value)=='rtl'?{left:'35px !important'}:{right:'35px !important'})
                }} onClick={()=>setShowPassword(false)}/>
                :null}
                {(value && !readOnly) ? (
                    <CloseIcon
                        className="closeIcon"
                        onClick={() => onClearClick && onClearClick()}
                    />
                ) : null}
            </Box>
            {
                error && message?.length ?
                    <Box sx={{
                        height: 'fit-content',
                        padding: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        flexWrap: 'wrap',
                        width: '95%',
                    }}>
                        {
                            message && message?.length > 0 ? message?.map((messg) => (
                                <span style={{ fontFamily: 'Cairo-Bold', fontSize: '14px', color: 'red', height: 'auto' }}>{messg}</span>
                            )) : null
                        }
                    </Box> : null}
        </ContainerOfInputFields>
    )
}

export default CustomTextField